<template>
  <v-dialog
    class='waf-filter-popup'
    :value="visiblePopup"
    :max-width="400"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='waf-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="(waf, index) in wafVendorOptions"
            :key="index"
            @click='addChip(waf)'
            class='waf'
            :class="waf"
          >
            {{ waf }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import {mapGetters} from 'vuex';

export default {
  name: 'SelectWAFFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedWAF: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedWAF);
      this.selectedWAF = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedWAF = [];
    },
    addChip(waf) {
      if (this.selectedWAF.includes(waf)) {
        this.selectedWAF = this.selectedWAF.filter(item => item !== waf);
      } else {
        this.selectedWAF.push(waf);
      }
    },
  },
  computed: {
    ...mapGetters([
      'wafOptions',
    ]),
    wafVendorOptions() {
      const options = [...this.wafOptions];
      options.push('No WAF');
      return options;
    },
    saveDisabled() {
      return this.selectedWAF.length === 0;
    },
  },
};
</script>

<style lang='scss'>
.waf-wrapper {
  .v-slide-group__wrapper {
    padding-left: 32px !important;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.popup-wrapper {
  max-width: rem(400);
  min-width: rem(400);
  padding: rem(32) rem(40);
  .waf-wrapper {
    min-width: rem(400);
    margin-left: -11%;
    margin-bottom: rem(-20);
    .waf {
      margin-bottom: rem(6);
      color: var(--text-secondary);
      background-color: var(--bg-tertiary);
      &__icon {
        width: rem(25);
        margin-right: rem(5);
      }
    }
  }

  .title {
    color: var(--text-primary);
    font-size: rem(14) !important;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: rem(16);
    text-transform: uppercase;
    padding-bottom: rem(23);
  }

  .buttons {

    text-align: right;
    padding-top: rem(30);

    .no-button {
      box-sizing: border-box;
      height: rem(32);
      width: rem(86);
      border: 1px solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: rem(32);
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
    }

  }
}

</style>
